export const PICKUP_TYPES = Object.freeze({
  INSTORE: 'INSTORE',
  CURBSIDE: 'CURBSIDE',
})
